import { WContainer } from '@next-nx/shared-ui/atoms'
import React from 'react'
import styles from './LandingDisclaimer.module.sass'
import { MenuItemType } from '@next-nx/utils/types'


interface Props {
  item: MenuItemType | undefined
  className?: string
}

const LandingDisclaimer = (props: Props) => {

  const {
    item = undefined,
    className = '',
  } = props

  return item?.description ? (
    <div
      className={`${styles.landingDisclaimer} ${className}`}
      dangerouslySetInnerHTML={{ __html: item.description }}
    />
  ) : <></>
}

export default LandingDisclaimer
